import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Payment } from 'src/app/models/payment';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/micro-services/user/models/user';
import { PaymentService } from 'src/app/micro-services/payment/services/payment.service';
import { PaymentServiceService } from 'src/app/services/payment-service.service';

@Component({
  selector: 'app-last-payments-list',
  templateUrl: './last-payments-list.component.html',
  styleUrls: ['./last-payments-list.component.scss'],
})
export class LastPaymentsListComponent implements OnInit {

  payments : Payment[] = [];
  coach : User;
  constructor(
    private ApiProviderService : ApiProviderService,
    private router : Router,
    private userService : UserService,
    private paymentService : PaymentServiceService
  ) { }

  ngOnInit() {
    this.coach = this.userService.getUser();
    this.paymentService.lastPayments$.subscribe({
      next: (res) => {
        this.payments = res;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  goToPaymentsPage() {
    // Vous pouvez naviguer vers l'URL souhaitée ici
    this.router.navigate(['/coach/payments-list']);
  }

}
